import * as types from '../mutation-types';
import ConversationAPI from '../../api/inbox/conversation';
const state = {
  records: {},
};

export const getters = {
  getUserList: $state => id => {
    return $state.records[Number(id)] || [];
  },
  getTypingPreviewByUser: $state => (conversationId, user) => {
    const records = $state.records[Number(conversationId)] || [];
    const match = records.find(
      r => r.id === user.id && String(r.type) === String(user.type)
    );
    return match?.typingPreview || '';
  },
};

export const actions = {
  toggleTyping: async (
    _,
    { status, conversationId, isPrivate, typingPreview = '' }
  ) => {
    try {
      await ConversationAPI.toggleTyping({
        status,
        conversationId,
        isPrivate,
        typingPreview,
      });
    } catch (error) {
      // Handle error
    }
  },
  create: ({ commit }, { conversationId, user, typingPreview = '' }) => {
    commit(types.default.ADD_USER_TYPING_TO_CONVERSATION, {
      conversationId,
      user: {
        ...user,
        typingPreview:
          typingPreview || user?.typingPreview || user?.typing_preview || '',
        typingPreviewUpdatedAt: Date.now(),
      },
    });
  },
  updatePreview: ({ commit }, { conversationId, user, typingPreview = '' }) => {
    commit(types.default.UPDATE_USER_TYPING_PREVIEW_IN_CONVERSATION, {
      conversationId,
      user,
      typingPreview,
    });
  },
  destroy: ({ commit }, { conversationId, user }) => {
    commit(types.default.REMOVE_USER_TYPING_FROM_CONVERSATION, {
      conversationId,
      user,
    });
  },
};

export const mutations = {
  [types.default.ADD_USER_TYPING_TO_CONVERSATION]: (
    $state,
    { conversationId, user }
  ) => {
    const records = $state.records[conversationId] || [];
    const idx = records.findIndex(
      record => record.id === user.id && record.type === user.type
    );
    const nextRecords =
      idx === -1
        ? [...records, user]
        : records.map((r, i) => (i === idx ? { ...r, ...user } : r));
    $state.records = {
      ...$state.records,
      [conversationId]: nextRecords,
    };
  },
  [types.default.UPDATE_USER_TYPING_PREVIEW_IN_CONVERSATION]: (
    $state,
    { conversationId, user, typingPreview }
  ) => {
    const records = $state.records[conversationId] || [];
    const idx = records.findIndex(
      record => record.id === user.id && record.type === user.type
    );
    if (idx === -1) {
      // If we haven't received typing_on yet, ignore silently.
      return;
    }
    const updated = records.map((r, i) =>
      i === idx
        ? {
            ...r,
            typingPreview: typingPreview || '',
            typingPreviewUpdatedAt: Date.now(),
          }
        : r
    );
    $state.records = {
      ...$state.records,
      [conversationId]: updated,
    };
  },
  [types.default.REMOVE_USER_TYPING_FROM_CONVERSATION]: (
    $state,
    { conversationId, user }
  ) => {
    const records = $state.records[conversationId] || [];
    const updatedRecords = records.filter(
      record => record.id !== user.id || record.type !== user.type
    );
    $state.records = {
      ...$state.records,
      [conversationId]: updatedRecords,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
